type Roles = {
  ADMIN: string;
  USER: string;
};

export const ROLES: Roles = {
  ADMIN: "Admin",
  USER: "User",
};
